"use client"

import { type LucideIcon } from "lucide-react"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarFooter,
} from "@/components/ui/sidebar"
import { ChevronRightIcon } from "@radix-ui/react-icons"
import { cn } from "@/lib/utils"
import { RestaurantsFeedback } from "./restaurants/restaurants-feedback"

interface NavItem {
  title: string;
  url: string;
  icon?: LucideIcon;
  items?: NavSubItem[];
  isActive?: boolean;
  disabled?: boolean;
}

interface NavSubItem {
  title: string;
  url: string;
  disabled?: boolean;
}

interface NavMainProps {
  items: NavItem[];
  onNavClick?: (e: React.MouseEvent<HTMLAnchorElement>, url: string) => void;
}

export function NavMain({ items, onNavClick }: NavMainProps) {
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Navigation</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible
            key={item.title}
            asChild
            defaultOpen={item.isActive}
            className="group/collapsible"
          >
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                <SidebarMenuButton 
                  tooltip={item.disabled ? `${item.title} (Coming Soon)` : item.title}
                  className={cn(item.disabled && "opacity-50 cursor-not-allowed")}
                >
                  {item.icon && <item.icon />}
                  <span>{item.title}{item.disabled && " (Coming Soon)"}</span>
                  {!item.disabled && (
                    <ChevronRightIcon className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                  )}
                </SidebarMenuButton>
              </CollapsibleTrigger>
              {!item.disabled && (
                <CollapsibleContent>
                  <SidebarMenuSub>
                    {item.items?.map((subItem: NavSubItem) => (
                      <SidebarMenuSubItem key={subItem.title}>
                        <SidebarMenuSubButton asChild>
                          <a href={subItem.url} onClick={(e) => onNavClick?.(e, subItem.url)}>
                            <span>{subItem.title}</span>
                          </a>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                </CollapsibleContent>
              )}
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
